var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgServicesSolid = function SvgServicesSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 17.05a7 7 0 0 1 7 0 7 7 0 0 1 7 0M5 6.938a7 7 0 0 1 7 0 7 7 0 0 1 7 0M5 6.938v10.11M12 6.938v10.11M19 6.938v10.11",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 7.388a6.25 6.25 0 0 0-5.5 0v8.477a7.75 7.75 0 0 1 5.5 0V7.388Zm-7 0v8.477a7.75 7.75 0 0 0-5.5 0V7.388a6.25 6.25 0 0 1 5.5 0ZM15.5 9.75c-.452 0-.901.05-1.34.145a.75.75 0 1 1-.32-1.465 7.75 7.75 0 0 1 3.32 0 .75.75 0 0 1-.32 1.465 6.25 6.25 0 0 0-1.34-.145Zm-1.34 3.145a6.25 6.25 0 0 1 2.68 0 .75.75 0 0 0 .32-1.465 7.748 7.748 0 0 0-3.32 0 .75.75 0 0 0 .32 1.465Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 7h2.5v12.5h-19V7H5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
};
export default SvgServicesSolid;